import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FieldLabel, Panel, SCHEMAS } from "@/admin/ui";
import { ImageField } from "@/admin/ImageField";

export const AdvancedSeoPanel = ({ form, patch }) => (
  <Panel title="SEO avanzado y redes" description="Opcional. Si lo dejas vacío se usan los valores automáticos." testid="editor-advanced-seo-panel">
    <div className="space-y-4">
      <div>
        <FieldLabel>Firma / autor</FieldLabel>
        <Input value={form.author || ""} onChange={(e) => patch({ author: e.target.value })} placeholder="Redacción El Noticiero" data-testid="editor-author-input" />
      </div>
      <div>
        <FieldLabel>Tipo de contenido (datos estructurados)</FieldLabel>
        <Select value={form.schema_type || "default"} onValueChange={(v) => patch({ schema_type: v === "default" ? null : v })}>
          <SelectTrigger data-testid="editor-schema-type-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="default">El de por defecto</SelectItem>
            {SCHEMAS.map(([k, label]) => <SelectItem key={k} value={k}>{label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div>
        <FieldLabel hint="si se publicó antes en otra web">URL canónica</FieldLabel>
        <Input value={form.canonical_url || ""} onChange={(e) => patch({ canonical_url: e.target.value })} placeholder="https://…" data-testid="editor-canonical-input" />
      </div>
      <label className="flex items-start justify-between gap-3 border border-border p-3">
        <span><span className="text-sm font-medium block">Ocultar en buscadores</span><span className="text-xs text-muted-foreground">Se ve en la web, pero Google no la indexa (noindex).</span></span>
        <Switch checked={!!form.noindex} onCheckedChange={(v) => patch({ noindex: v })} data-testid="editor-noindex-switch" />
      </label>
      <div className="border-t border-border pt-4 space-y-4">
        <p className="kicker text-[10px] text-muted-foreground">Al compartir en redes</p>
        <div>
          <FieldLabel hint={`${(form.social_title || "").length}/70`}>Título para redes</FieldLabel>
          <Input value={form.social_title || ""} onChange={(e) => patch({ social_title: e.target.value })} placeholder="Si lo dejas vacío se usa el título SEO" data-testid="editor-social-title-input" />
        </div>
        <div>
          <FieldLabel hint={`${(form.social_description || "").length}/200`}>Descripción para redes</FieldLabel>
          <Textarea rows={2} value={form.social_description || ""} onChange={(e) => patch({ social_description: e.target.value })} data-testid="editor-social-description-input" />
        </div>
        <ImageField label="Imagen para redes" hint="1200×630" value={form.social_image_url} onChange={(v) => patch({ social_image_url: v })} testid="editor-social-image" />
      </div>
    </div>
  </Panel>
);
